import type {
  SearchResponse,
  PodcastResponse,
  EpisodesResponse,
  TrendingResponse,
  CategoriesResponse,
} from '@/types';

let apiRoot = '/wp-json/';
let apiNonce = '';

export function configureApi(root: string, nonce: string) {
  apiRoot = root;
  apiNonce = nonce;
}

async function fetchApi<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const url = `${apiRoot}cuebes/v1${endpoint}`;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (apiNonce) {
    headers['X-WP-Nonce'] = apiNonce;
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || `HTTP error ${response.status}`);
  }

  return response.json();
}

export async function searchPodcasts(
  query: string,
  max: number = 20
): Promise<SearchResponse> {
  return fetchApi<SearchResponse>('/podcasts/search', {
    method: 'POST',
    body: JSON.stringify({ q: query, max }),
  });
}

export async function getPodcast(id: number): Promise<PodcastResponse> {
  return fetchApi<PodcastResponse>(`/podcasts/${id}`);
}

export async function getEpisodes(
  podcastId: number,
  max: number = 50
): Promise<EpisodesResponse> {
  return fetchApi<EpisodesResponse>(`/podcasts/${podcastId}/episodes?max=${max}`);
}

export async function getTrending(
  max: number = 20,
  category?: string
): Promise<TrendingResponse> {
  const params = new URLSearchParams({ max: max.toString() });
  if (category) {
    params.append('cat', category);
  }
  return fetchApi<TrendingResponse>(`/podcasts/trending?${params.toString()}`);
}

export async function getCategories(): Promise<CategoriesResponse> {
  return fetchApi<CategoriesResponse>('/podcasts/categories');
}
